import styled from 'styled-components'

const ProductInfoContainerUi = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`

export default ProductInfoContainerUi
